import { getStatusLabel } from '../utils';

type StatusLabelProps = {
  enabled: boolean;
};

export const StatusLabel = ({ enabled }: StatusLabelProps) => (
  <>{getStatusLabel(enabled)}</>
);
